(() => {
  const ROOT_SELECTORS = [
    "#wc_review_section",
    ".wc_testimonial_section.wc_rivyo_widget_root"
  ];

  const observedRoots = new WeakSet();

  function replaceHeading(el) {
    if (!el || el.dataset.rivyoNoH) return;

    const tag = el.tagName.toLowerCase();
    if (!/^h[1-6]$/.test(tag)) return;

    const level = tag.slice(1);
    const div = document.createElement("div");

    const existing = el.getAttribute("class") || "";
    div.className = (existing ? existing + " " : "") + tag;

    div.innerHTML = el.innerHTML;

    for (const { name, value } of [...el.attributes]) {
      if (name === "class") continue;
      div.setAttribute(name, value);
    }

    el.dataset.rivyoNoH = "1";
    el.replaceWith(div);
  }

  function run(root) {
    root.querySelectorAll("h1,h2,h3,h4,h5,h6").forEach(replaceHeading);
  }

  function observeRoot(root) {
    if (!root || observedRoots.has(root)) return;
    observedRoots.add(root);

    run(root);

    new MutationObserver(() => run(root))
      .observe(root, { childList: true, subtree: true });
  }

  function findAndObserveRoots() {
    ROOT_SELECTORS.forEach(sel => {
      document.querySelectorAll(sel).forEach(observeRoot);
    });
  }

  function init() {
    // sofort versuchen
    findAndObserveRoots();

    // falls App-Blöcke später kommen: ganzen DOM beobachten
    new MutationObserver(() => findAndObserveRoots())
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", init);
})();